import computeStyle from './compute-style/'
import { Timeline, applyStyle, hide, show } from './animate/'
import { routeCurrent } from '@iez/core/router'
import { scrollBehaviorResult } from '@iez/core/router/'
import waitFor from '@iez/lib/wait-for/'

const candidates = {}
const addCandidate = ({
  element,
  id,
  isImage
}) => {
  candidates[id] = {
    element,
    style: null,
    timeline: Timeline(),
    isImage,
    fullPath: routeCurrent.fullPath
  }
}

// ON BEFORE ENTER : calculer les positions et style "candidates"
// Les mettres quelque part pour réutiliser

export const onBeforeGuard = async (to, from, next) => {
  Object.entries(
    candidates
  ).forEach(([
    id,
    { element, isImage }
  ]) => {
    const style = computeStyle({
      element,
      isImage
    })
    candidates[id].style = style
  })
  next()
}

/**
 * Step 1 : we prepare target that will transition
 */
export const directive = {
  install (Vue) {
    Vue.directive('shared-element', {
      async inserted(target, binding) {
        let isDisabled = true
        if (isDisabled) {
          return
        }
        // v-shared-element:id
        const { arg: id } = binding

        const resolveIsImage = ({ node }) =>
          node.classList.contains(`v-image`) ||
          Array.from(node.children)
            .some(child => resolveIsImage({ node: child }))

        const isImage = resolveIsImage({
          node: target
        })

        /**
         * Waiting next frame to compute right sizing
         */
        await new Promise(resolve => requestAnimationFrame(resolve))

        const candidate = candidates[id]
        if (
          candidate && (
            routeCurrent.fullPath !==
            candidate.fullPath
          )
        ) {
          const { y: scrollBehaviorY } = await waitFor({
            dependencies: () => scrollBehaviorResult.value
          })
          const {
            element: elementToAnimate,
            style: elementToAnimateStyle,
            timeline
          } = candidate

          document.body.appendChild(elementToAnimate)
          applyStyle({
            element: elementToAnimate,
            style: { ...elementToAnimateStyle },
            isImage,
            scrollBehaviorY
          })

          hide({ element: target })

          const targetStyle = computeStyle({
            element: target,
            isImage
          })

          timeline.add({
            element: elementToAnimate,
            style: { ...targetStyle },
            isImage,
            scrollBehaviorY
          })
          timeline.process()
            .then(() => {
              elementToAnimate.remove()
              show({ element: target })
              addCandidate({
                element: target,
                id,
                isImage
              })
            })
        } else {
          addCandidate({
            element: target,
            id,
            isImage
          })
        }
      }
    })
  }
}
